import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.css'],
    standalone: false
})
export class PaginatorComponent implements OnInit {
  @Input() totalCount: number;
  @Input() pageSize: number;
  @Input() pageSizeOptions = [];
  @Input() pageIndex: number;
  @Input() enablePageSizeSelector = true;
  @Input() enabled = true;

  @Output() page: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  constructor() {
  }

  ngOnInit() {
  }

  selectPageSize(value: any) {
    this.pageSize = value;
    this.pageIndex = 0;

    this.emitPage();
  }

  previousPage() {
    this.pageIndex--;

    this.emitPage();
  }

  nextPage() {
    this.pageIndex++;

    this.emitPage();
  }

  private emitPage() {
    this.page.emit({pageSize: this.pageSize, length: this.totalCount, pageIndex: this.pageIndex});
  }

  getOffset(): number {
    return this.pageIndex * this.pageSize;
  }

  getLastActiveIndex() {
    return Math.min(this.getOffset() + +this.pageSize, this.totalCount);
  }

  isLastPage() {
    return this.getLastActiveIndex() === this.totalCount;
  }

  isFirstPage() {
    return this.pageIndex === 0;
  }
}
